<template>
    <div class="register_upload" v-loading="isUploadLoading">
        <el-upload
            class="upload-demo"
            action=""
            :accept="accept"
            :limit="limit"
            :before-upload="getUploadInfo"
            :http-request="submitUpload"
            :show-file-list="showFileList">
            <i class="el-icon-upload upload_icon" v-if="uploadDisplayType === 'icon'"></i>
            <el-button class="upload_button" :size="btnSize" type="primary" v-if="uploadDisplayType === 'button'">{{text}}</el-button>
            <span class="upload_text" v-if="uploadDisplayType === 'text'" v-html="text"></span>
            <i class="el-icon-upload" v-if="uploadDisplayType === 'iconAndText'"></i>
            <span class="upload_text" v-if="uploadDisplayType === 'iconAndText'" v-html="text"></span>
        </el-upload>
    </div>
</template>

<script>
/**
 * 组件使用方式：
 * 传入uploadDisplayType 控制是显示图标、按钮、文字、图标加文字 【传入 icon ||  button || text || iconAndText || iconAndText】
 * 传入text 控制显示的文字内容
 * 传入flag 用于同一组件多个上传按钮时做区分传, 字符串即可
 * 成功返回 返回整个数据对象 和 标志位flag
 * **/
import { getLogistics, getLogisticsUpload } from '../../../../api/upload';
// import md5 from 'js-md5';
import config from '@/config/user.env';
// const BYTES_PER_CHUNK = 10 * 512 * 1024; // 每个文件切片大小定为10MB
export default {
    props: {
        text: {
            type: String,
            default() {
                return '';
            }
        },
        btnSize: {
            type: String,
            default() {
                return 'small';
            }
        },
        uploadDisplayType: {
            type: String,
            default() {
                return 'icon';
            }
        },
        accept: {
            type: String,
            default() {
                return '';
            }
        },
        flag: {
            type: String,
            default() {
                return '';
            }
        },
        dataUpload: {
            type: Object
        },
        limit: {
            type: Number,
            default() {
                return 1;
            }
        },
        showFileList: {
            type: Boolean,
            default() {
                return false;
            }
        },
        type: {
            type: String,
            default() {
                return '1';
            }
        }
    },
    data() {
        return {
            isUploadLoading: false,
            certification: '',
            contentLength: 0,
            uploadName: '',
            appid: config.uploadAppId,
            appkey: config.uploadAppKey
        };
    },
    methods: {
        getUploadInfo(file) {
            const isPDF = file.type.split('/');
            const isJPG = isPDF[0] === 'image';
            // if (!isJPG) {
            //     this.$message.closeAll();
            //     this.$message.error('仅支持上传图片');
            //     return false;
            // }
            if (isJPG && file.size > 10 * 1024 * 1024) {
                this.$message.warning('文件超过限制大小 ' + 10 + 'M！');
                return false;
            }
            const index = file.name.lastIndexOf('.');
            const originName = file.name.substring(0, index);
            const originNameType = file.name.substring(index, file.length);
            this.uploadName = originName + '_' + new Date().getTime() + originNameType;
            this.contentLength = file.size;
            return true;
        },
        submitUpload(uploadData) {
            this.simpleUpload(uploadData);
        },
        async simpleUpload(uploadData) {
            const file = new File([uploadData.file], uploadData.file.name, {
                type: uploadData.file.type
            });
            const formData = new FormData();
            formData.append('files', file);
            formData.append('jobId', this.dataUpload.jobId);
            this.isUploadLoading = true;
            const requestMethod = this.type === '2' ? getLogisticsUpload : getLogistics;
            requestMethod(formData).then((res) => {
                if (res && res.code === '0') {
                    this.$message.success('上传成功');
                    this.isUploadLoading = false;
                    this.$emit('uploadSuccess', { data: res.data, flag: this.flag });
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
/deep/.upload-demo{
    display: flex;
    align-items: center;
    .el-upload-list--text{
        width: 220px;
    }
}
</style>
